import angular from 'angular';
import syncSettingsComponent from './syncSettings.component';

let syncSettingsModule = angular.module('syncSettings', []).component('syncSettings', syncSettingsComponent);

export default syncSettingsModule;



// WEBPACK FOOTER //
// ./app/components/syncSettings/syncSettings.js